import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03d4ca30&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=03d4ca30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4ca30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d4ca30')) {
      api.createRecord('03d4ca30', component.options)
    } else {
      api.reload('03d4ca30', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03d4ca30&scoped=true&", function () {
      api.rerender('03d4ca30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JsonEditor/index.vue"
export default component.exports